import { Checkbox, Form } from 'antd';
import generatePicker from 'antd/es/date-picker/generatePicker';

import { dateGenerateConfig } from 'app/components/fields/dateGenerateConfig';
import {
  DATE_FORMATS,
  DAYS_OPTIONS,
} from 'app/typings/core/extranet/constants/days';
import {
  addDays,
  addYears,
  isAfter,
  isBefore,
  startOfDay,
} from 'app/utils/dayjs';

import { RULES } from '../ExperienceBulkEdit';
import styles from '../ExperienceBulkEdit.module.scss';

type DatesSelectorProps = {
  startDate?: Date;
  endDate?: Date;
  fromDate?: Date;
  closedDays?: number[];
};

const DatePicker = generatePicker<Date>(dateGenerateConfig);

const TODAY = new Date();

export const DatesSelector = ({
  startDate,
  endDate,
  fromDate,
  closedDays = [],
}: DatesSelectorProps) => {
  return (
    <section className={styles.selectDates}>
      <h2>Select dates</h2>
      <div className={styles.selectDatesPickers}>
        <div className={styles.from}>
          <Form.Item
            label="From"
            name="startDate"
            rules={RULES}
            initialValue={startDate}
          >
            <DatePicker
              format={DATE_FORMATS.DATE_PICKER_DAY}
              disabledDate={(d) =>
                !d ||
                isBefore(d, startOfDay(TODAY)) ||
                isAfter(d, addYears(TODAY, 1))
              }
              showToday
            />
          </Form.Item>
        </div>
        <div className={styles.upTo}>
          <Form.Item
            label="Up to and including:"
            name="endDate"
            rules={RULES}
            initialValue={endDate}
          >
            <DatePicker
              format={DATE_FORMATS.DATE_PICKER_DAY}
              disabledDate={(d) =>
                !d ||
                isBefore(d, addDays(fromDate || TODAY, 1)) ||
                isAfter(d, addYears(TODAY, 2))
              }
              showToday
              disabled={!fromDate}
            />
          </Form.Item>
        </div>
      </div>
      <div className={styles.selectDatesApplyTo}>
        <p className={styles.subtitle}>Apply changes to:</p>
        <div className={styles.listCheckbox}>
          <Form.Item name="days">
            <Checkbox.Group>
              {DAYS_OPTIONS.map((day) => (
                <Checkbox
                  key={day.value}
                  value={day.value}
                  disabled={closedDays.includes(day.value)}
                  className={
                    closedDays.includes(day.value)
                      ? styles.closedDay
                      : undefined
                  }
                >
                  {day.label}
                </Checkbox>
              ))}
            </Checkbox.Group>
          </Form.Item>
        </div>
      </div>
    </section>
  );
};
